import VueDateTimePicker from '@bx/vue-date-time-picker';
import VueSelect from 'vue-select';
import { Can } from '@casl/vue';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import vue2Dropzone from 'vue2-dropzone';
import draggable from 'vuedraggable';
import VueTypeaheadBootstrap from '@vue-bootstrap-components/vue-bootstrap-autocomplete';
import Navbar from './Navbar.vue';

/**
 * Setup Global accessible Components for the Vue instance
 * @param {VueConstructor<Vue>} instance
 */
// eslint-disable-next-line import/prefer-default-export
export function setupGlobalComponents(instance) {
  // eslint-disable-next-line vue/multi-word-component-names
  instance.component('Navbar', Navbar);

  instance.component('VueDateTimePicker', VueDateTimePicker);

  instance.component('VSelect', VueSelect);

  // eslint-disable-next-line vue/multi-word-component-names
  instance.component('Can', Can);

  instance.component('VDropzone', vue2Dropzone);

  // eslint-disable-next-line vue/multi-word-component-names
  instance.component('Draggable', draggable);

  instance.component('VTypeahead', VueTypeaheadBootstrap);
}
